import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getAccountNoteListData } from './mockData'
import type { IAccountNote } from '~/types/note/models'

export const {
  getNotes: getAccountNotes,
  postNote: postAccountNote,
  patchNote: patchAccountNote,
  deleteNote: deleteAccountNote,
  handlers,
} = makeNoteAPIs<IAccountNote>({
  apiPathEntityNamePrefix: 'account',
  getNoteListDataFn: getAccountNoteListData,
})
